<template>
  <div class="version">
    <version-container></version-container>
  </div>
</template>
<script>
import VersionContainer from '@/components/version/Container.vue'
export default {
  name: 'version',
  components: {
    VersionContainer
  }
}
</script>
<style lang="stylus">
.version
  height 100%
  width 100%
  background #f7f9fb
</style>
